const API_BASE = process.env.REACT_APP_API_BASE;
console.log(API_BASE);
export const api = {
  getOperatorByPassword: async (password) => {
    const response = await fetch(`${API_BASE}/getOperatorByUniqueIdentifier/${password}`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  getAllDs5Role: async () => {
    const response = await fetch(`${API_BASE}/getAllDs5Role`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  getAllMovements: async () => {
    const response = await fetch(`${API_BASE}/getAllMovement`);

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    // ✅ obligatoire avec fetch
  return response.json(); // ✅ tableau des mouvements
  },

  getCurrentMovement: async (serial) => {
    const response = await fetch(`${API_BASE}/getlastmovement/${serial}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    return response.json();
  },

  saveMovement: async (data) => {
    const response = await fetch(`${API_BASE}/saveDS5HistoryWithGrade`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  getAllDs5Panne: async () => {
    const response = await fetch(`${API_BASE}/getAllDs5Panne`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`Impossible de charger les pannes: ${response.status}`);
    return response.json();
  },

  createDs5Panne: async (panneData) => {
    console.log('Création panne avec données complètes:', panneData);

    try {
      const payload = {
        panne: panneData.panne,
        id_nextjob: panneData.id_nextjob
      };

      if (panneData.grade) {
        payload.grade = panneData.grade;
      }

      console.log('Payload final:', payload);

      const response = await fetch(`${API_BASE}/createDs5Panne`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      console.log('Réponse HTTP:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Erreur API:', {
          status: response.status,
          statusText: response.statusText,
          body: errorText
        });
        throw new Error(`Erreur création panne: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      console.log('Panne créée avec succès:', result);
      return result;

    } catch (err) {
      console.error('Erreur fatale création panne:', err);
      throw err;
    }
  },
 getPanne: async (id_movement, id_nextjob, serial_number) => {
  let url;

  if (id_movement) {
    url = `${API_BASE}/getMovementCadence?id_movement=${id_movement}&id_nextjob=${id_nextjob}&serial_number=${serial_number}`;
  } else {
    url = `${API_BASE}/getMovementCadence?id_nextjob=${id_nextjob}&serial_number=${serial_number}`;
  }

  const response = await fetch(url);

  if (response.status === 404) return null; // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json(); // parse JSON
},
getDailyCadance: async(operator,startdate,enddate,id_movement)=>{
  const url = `${API_BASE}/getDailyCadance?operator=${operator}&startdate=${startdate}&enddate=${enddate}&id_movement=${id_movement}`;

  const response = await fetch(url);

  if (response.status === 404) return null;  // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json();  // parse JSON


},
getfulltestSession: async (serial_number) => {
  // Parse the date string to extract the hour


  // Build the URL with dateRange and timeStart/timeEnd
  const url = `${API_BASE}/getSessionBySn/${serial_number}`;

  const response = await fetch(url);

  if (response.status === 404) return null; // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json(); // parse JSON
},
getReparedPannedata: async ()=>{
  const url = `${API_BASE}/getPanneDetails`;

  const response = await fetch(url);

  if (response.status === 404) return null; // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json(); // parse JSON
},
getRebutata: async ()=>{
  const url = `${API_BASE}/getCauseRebut`;

  const response = await fetch(url);

  if (response.status === 404) return null; // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json(); // parse JSON
},
getCode: async(id)=>{
const url = `${API_BASE}/getCodeDescriptionByIdCode/${id}`;

  const response = await fetch(url);

  if (response.status === 404) return null; // no record found
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  return await response.json(); // parse JSON
},
getObjective: async(mouvemnet) =>{
  const url = `${API_BASE}/getObjective?id_mvt=${mouvemnet}`
  const result = await fetch(url);

  if (!result.ok) throw new Error(`HTTP ${result.status}`);
  return await result.json();

},
getSessionStatusBySn: async (serial_number) => {
  const url = `${API_BASE}/getSessionBySn/${serial_number}`;

  const response = await fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  if (response.status === 404) return null; // no session found
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} - ${response.statusText}`);
  }

  return await response.json();
},
getPalette: async (id_mvtpal) => {
  let url = `${API_BASE}/getPalette`;

  // Add query param if provided
  if (id_mvtpal !== undefined && id_mvtpal !== null) {
    url += `?id_mvtpal=${id_mvtpal}`;
  }

  const response = await fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch palettes');
  }

  return response.json();
},

createPalette: async (sn_palette, grad, color,id_mvtpal) => {
  const url = `${API_BASE}/createPalette`;

  const response = await fetch(url, {
    method: "POST",                // ✅ POST
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({         // ✅ send data
      sn_palette,
      grad,
      color,
      id_mvtpal
    })
  });

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} - ${response.statusText}`);
  }

  return await response.json();
},

updatePalette: async (id,id_mvtpal) => {
  const url = `${API_BASE}/updatePalette/${id}`;

  const response = await fetch(url, {
    method: "PUT",                // ✅ POST
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({         // ✅ send data
     id_mvtpal
    })
  });

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} - ${response.statusText}`);
  }

  return await response.json();
},
updatehistoryPalette: async (id_palette, new_nextjob,movement,tester,operator,version) => {
  const url = `${API_BASE}/updateAllHistoryByPalette/`;

  const response = await fetch(url, {
    method: "POST",                // ✅ POST
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({         // ✅ send data
     id_palette,
     new_nextjob,
     movement,
     tester,
     operator,
     version
    })
  });

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} - ${response.statusText}`);
  }

  return await response.json();
},


}